export default __webpack_public_path__ + "41d9828a867af27a2f11e57d677663ff.webp";